import type { IReportColumn } from '~/presentation/reports/common/Visualization/types';
import type { OrderByFields, ReportColumnLayoutMap } from '../../types';

import { SortableHeaderWithTooltip } from './SortableHeaderWithTooltip';
import { getColumnLayoutStyles } from '../../utils';
import { CheckIcon } from '@shopify/polaris-icons';
import { SortableHeader } from './SortableHeader';
import { Box, Icon } from '@shopify/polaris';
import { useState } from 'react';
import { cls } from '~/utils';

interface HeaderProps {
  columns: IReportColumn[];
  columnLayoutMap: ReportColumnLayoutMap;
  activeColumn?: string;
  orderBy?: OrderByFields;
  showSummary?: boolean;
  onChangeOrderBy?: (field: string) => void;
}

export const Header = ({
  columns,
  columnLayoutMap,
  activeColumn,
  orderBy,
  showSummary,
  onChangeOrderBy,
}: HeaderProps) => {
  const [itemHovering, setItemHovering] = useState<string>();

  return (
    <div
      className={cls('GReportTable__Header', {
        'GReportTable__Header--hide-summary': !showSummary,
      })}
    >
      {columns.map((item) => {
        const isTooltipCard = !!item.tooltipCardProps;

        const SortableHeaderComponent = isTooltipCard ? SortableHeaderWithTooltip : SortableHeader;

        return (
          <div
            key={item.name}
            className="GReportTable__Header-Cell"
            style={getColumnLayoutStyles(columnLayoutMap[item.name])}
            onMouseEnter={() => setItemHovering(item.name)}
            onMouseLeave={() => setItemHovering(undefined)}
          >
            {activeColumn === item.name && (
              <Box>
                <Icon source={CheckIcon} />
              </Box>
            )}

            <SortableHeaderComponent
              item={item}
              orderBy={orderBy}
              itemHovering={itemHovering}
              onChangeOrderBy={onChangeOrderBy}
              {...item.tooltipCardProps}
            />
          </div>
        );
      })}
    </div>
  );
};
